import styled from "styled-components";

export const AppOrderWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 40px);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const AppOrderTitle = styled.div`
  color: #121212;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 10px;
`;

export const AppOrderToggleLabel = styled.div`
  color: #121212;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const AppOrderTitleToggle = styled.div<{
  isOn: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 20px;
  border-radius: 10px;
  background: #ecf0f3;
  position: relative;
`;

export const AppOrderTitleToggleCircle = styled.div<{
  isOn: boolean;
}>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${(p) => (p.isOn ? "#121212" : "rgb(128, 128, 128)")};
  position: absolute;
  left: ${(p) => (p.isOn ? "20px" : "0")};
  transition: left 0.3s ease-in-out;
`;

export const AppOrderList = styled.div`
  width: calc(100% - 20px);
  flex: 1;

  overflow-y: auto;

  border-radius: 8px;
  background: #ecf0f3;

  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 10px;
`;

export const AppOrderItem = styled.div`
  color: #121212;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.3px;
`;
